import { Component,EventEmitter,Optional} from '@angular/core';
import { FormBuilder,Validators,ControlContainer,FormGroup  } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseFpxFormComponent,ValidatorService } from '@fpx/core'; 
import { ScheduleHistoryDetailHelper, ScheduleHistoryDetailState } from './schedule-history-detail.helper';
import { SchedulerepService } from '../schedulerep-service/schedulerep.service';

 
@Component({
 selector: 'app-schedule-history-detail',
  templateUrl: './schedule-history-detail.component.html',
  styleUrls: ['./schedule-history-detail.component.scss'],
  providers : [ ScheduleHistoryDetailHelper]
  })

export class ScheduleHistoryDetailComponent extends BaseFpxFormComponent<ScheduleHistoryDetailHelper, ScheduleHistoryDetailState> {
  constructor(
    @Optional() controlContainer: ControlContainer,
    formBuilder: FormBuilder,
    private router: Router,
    public scheduleHistoryDetailHelper: ScheduleHistoryDetailHelper,
    public schedulerepService: SchedulerepService,
    private validatorService: ValidatorService
    
  ) {
    super(formBuilder, router,controlContainer, scheduleHistoryDetailHelper);
  }
      protected  readonly paymentId_minLength : any = 0;
      protected  readonly paymentCurrency_minLength : any = 0;
      protected  readonly nextPaymentDate_minLength : any = 0;
      protected  readonly beneName_minLength : any = 0;
      protected  readonly debitAccount_minLength : any = 0;
      protected  readonly creditAccount_minLength : any = 0;
      protected  readonly scheduleType_minLength : any = 0;
      protected  readonly status_minLength : any = 0;
   protected override doPreInit(): void {

   this.addFormControl('paymentId', '',  []   ,
		      [
		        this.validatorService.dataAvailabilityCheck(
		          this.embadedFormMode,
		          'paymentId',
		          this.schedulerepService,
		          this.dataAvailable$
		        ),
		      ],'blur',0,true,0);			   		 

   this.addFormControl('paymentCurrency', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('nextPaymentDate', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('beneName', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('debitAccount', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('creditAccount', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('scheduleType', '',  []    ,[],'blur',1,false,0);			   		 

   this.addFormControl('status', '',  []    ,[],'blur',1,false,0);			   		 
	this.setDataService(this.schedulerepService);
  }
 

  protected override doPostInit(): void {
   
  }
  
}
